/**
 * Chart and inline-style colours read from the design-system tokens
 * (src/styles/global.css), so a chart follows the palette like the rest of
 * the page. `hsl(var(--x))` works in inline styles and in SVG presentation
 * attributes, which is where recharts puts its fills.
 */
export const chartColors = {
  brand: "hsl(var(--brand))",
  brandSoft: "hsl(var(--brand) / 0.45)",
  success: "hsl(var(--app-success))",
  warning: "hsl(var(--app-warning))",
  danger: "hsl(var(--app-danger))",
  info: "hsl(var(--app-info))",
  warm: "hsl(var(--accent-warm-strong))",
  muted: "hsl(var(--app-fg-subtle))",
  strong: "hsl(var(--app-fg-strong))",
} as const;

/** Categorical series, in the order a chart should assign them. */
export const chartSeries = [
  chartColors.brand,
  chartColors.info,
  chartColors.success,
  chartColors.warning,
  chartColors.warm,
] as const;

/** Traffic-light scale for a 0–100 score. */
export function scoreColor(value: number): string {
  if (value >= 70) return chartColors.success;
  if (value >= 40) return chartColors.warning;
  return chartColors.danger;
}
